import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconAward = ({ color = 'currentColor', size = 'xSmall', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" size={size} {...props}>
        <StyledPath
            d="M13.75 15.625H6.25C5.75272 15.625 5.27581 15.8225 4.92417 16.1742C4.57254 16.5258 4.375 17.0027 4.375 17.5V17.5C4.375 17.9973 4.57254 18.4742 4.92417 18.8258C5.27581 19.1775 5.75272 19.375 6.25 19.375H13.75C14.2473 19.375 14.7242 19.1775 15.0758 18.8258C15.4275 18.4742 15.625 17.9973 15.625 17.5V17.5C15.625 17.0027 15.4275 16.5258 15.0758 16.1742C14.7242 15.8225 14.2473 15.625 13.75 15.625V15.625Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            color="none"
        />
        <StyledPath
            d="M6.875 3.75C6.875 4.5788 7.20424 5.37366 7.79029 5.95971C8.37634 6.54576 9.1712 6.875 10 6.875C10.8288 6.875 11.6237 6.54576 12.2097 5.95971C12.7958 5.37366 13.125 4.5788 13.125 3.75C13.125 2.9212 12.7958 2.12634 12.2097 1.54029C11.6237 0.95424 10.8288 0.625 10 0.625C9.1712 0.625 8.37634 0.95424 7.79029 1.54029C7.20424 2.12634 6.875 2.9212 6.875 3.75V3.75Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            color="none"
        />
        <StyledPath
            d="M11.8751 15.625H8.12514L6.08348 8.46833C6.0304 8.28253 6.02112 8.08695 6.05638 7.89695C6.09163 7.70696 6.17045 7.52772 6.28666 7.37333C6.40286 7.21893 6.55327 7.09358 6.72608 7.00711C6.8989 6.92065 7.08941 6.87543 7.28264 6.875H12.7176C12.9109 6.87543 13.1014 6.92065 13.2742 7.00711C13.447 7.09358 13.5974 7.21893 13.7136 7.37333C13.8298 7.52772 13.9087 7.70696 13.9439 7.89695C13.9792 8.08695 13.9699 8.28253 13.9168 8.46833L11.8751 15.625Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            color="none"
        />
    </StyledSvg>
);
